import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FormContextProvider, DisplaySpinnerContext } from "../../../context/ContextIndex";
import { AppForm, DynamicFormContainer, notifyToast, ToastType, TabPanel } from "../../../components";
import { getGrossBranchDefaultValue, getGrossBranchSchema } from "./Schema";
import { selectSessionConfig } from "../../../store/store-selector";
import { saveGrossBranch } from "../api-handler/api-handler";
import { useGrossBranchFormData } from "../../../hooks/useGrossBranchFormData";
import AppFormRootContainer from "../../../components/app-components/app-form-root-container/AppFormRootContainer";

const CreateGrossBranchForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const EditGrossBranchId = searchParams.get("GrossBranchId");
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const navigationData = location.state;
  const createGrossBranchLookupData = useGrossBranchFormData(settingsConfig.businessCode, settingsConfig.countryCode);

  const [formdata, setFormdata] = useState({
    schema: getGrossBranchSchema({serviceTypeList : [], sectorList : [], branchList : []}),
    appformdata: null,
  });

  const defaultValue = getGrossBranchDefaultValue();

  const handleCancel = () => {
    try {
      navigate("/grossbranchlist");
    } catch (err) {
      alert(err);
    }
  };

  const onGrossBranchSubmit = async (data, formhandler) => {
    console.log("onGrossBranchSubmit");
    const { reset, clearErrors } = formhandler;
    try {
      clearErrors();
      spinnerCtx.setLoadingIndicator(true);
      const status = await saveGrossBranch(data, {
        EditGrossBranchId,
        settingsConfig,
        formdata: formdata.appformdata,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for Approval", ToastType.SUCCESS);
        handleCancel();
      } else {
        notifyToast(status.errorMessage ? status.errorMessage : "Gross Branch creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
      if (status?.error) {
        reset(
          { ...data },
          {
            keepValues: true,
            keepSubmitCount: false,
            keepDirty: true,
            keepTouched: true,
          }
        );
      }
    } catch (err) {
      reset(
        { ...data },
        {
          keepValues: true,
          keepSubmitCount: false,
          keepDirty: true,
          keepTouched: true,
        }
      );
      alert(err);
    }
  };

  useEffect(() => {
    const setFormSchema = () => {
      try {
        let _lookUpData = {};
        _lookUpData.serviceTypeList = [];
        _lookUpData.sectorList = [];
        _lookUpData.branchList = [];
          
        if (
            createGrossBranchLookupData.marketSectorList &&
            createGrossBranchLookupData.serviceTypeList &&
            createGrossBranchLookupData.branchList
          ) {
          let _formData = navigationData ? { ...navigationData } : null;

          _lookUpData.serviceTypeList = createGrossBranchLookupData.serviceTypeList.map((item) => {
            if (_formData && item.ServiceTypeId === _formData.TypeId) {
              _formData.ServiceType = {
                id: item.ServiceTypeId,
                label: item.ServiceName,
              };
            }
            return {
              id: item.ServiceTypeId,
              label: item.ServiceName,
            };
          });

          _lookUpData.sectorList = createGrossBranchLookupData.marketSectorList.map((item) => {
            if (_formData && item.SectorId === _formData.SectorId) {
              _formData.Sector = {
                id: item.SectorId,
                label: item.SectorName,
              };
            }
            return {
              id: item.SectorId,
              label: item.SectorName,
            };
          });

          _lookUpData.branchList = createGrossBranchLookupData.branchList.map((item) => {
            if (_formData && item.BranchId === _formData.BranchId) {
              _formData.Branch = {
                id: item.BranchId,
                label: item.BranchName,
              };
            }
            return {
              id: item.BranchId,
              label: item.BranchName,
            };
          });

          if (_formData) {
            setFormdata((prevstate) => ({
              ...prevstate,
              schema: getGrossBranchSchema(_lookUpData),
              appformdata: getGrossBranchDefaultValue(_formData),
            }));
          } else {
            setFormdata((prevstate) => ({
              ...prevstate,
              schema: getGrossBranchSchema(_lookUpData),
            }));
          }
        }

      } catch (err) {
        alert(err);
      } finally {
        spinnerCtx.setLoadingIndicator(false);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    if (createGrossBranchLookupData) {
      setFormSchema(createGrossBranchLookupData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createGrossBranchLookupData]);

  return (
    <AppFormRootContainer>
      <TabPanel
        tabs={[
          {
            icon: "",
            label: t("grossBranchList.header"),
            children: (
              <FormContextProvider schema={formdata.schema} defaultValues={defaultValue} appformdata={formdata.appformdata}>
                <AppForm onSubmit={onGrossBranchSubmit}>
                  <DynamicFormContainer
                    header={EditGrossBranchId ? t("createGrossBranch.editGrossBranch") : t("createGrossBranch.header")}
                    onCancel={handleCancel}
                  />
                </AppForm>
              </FormContextProvider>
            ),
          },
        ]}
        selectedTab="0"
        onTabChange={() => { }}
      />
    </AppFormRootContainer>
  );
};

export default CreateGrossBranchForm;
